export const PHONE_DISPLAY = "912473544";
export const PHONE_HREF = "tel:+351912473544";
export const ADDRESS = "R. 28 de Setembro 6, 2625-159 Póvoa de Santa Iria";

export const IMAGES = {
  facade: "/images/IMG-20260909-WA0048.jpg",
  lounge: "/images/IMG-20260909-WA0044.jpg",
  treatmentRoom: "/images/IMG-20260909-WA0042.jpg",
  manicureDesk: "/images/IMG-20260909-WA0046.jpg",
  manicureLamps: "/images/IMG-20260909-WA0043.jpg",
  vanity: "/images/IMG-20260909-WA0045.jpg",
  station: "/images/IMG-20260909-WA0047.jpg",
};

export const SERVICES = [
  {
    id: "manicure",
    num: "01",
    title: "Manicure & Estética",
    desc: "Mãos impecáveis com acabamento de alta durabilidade e brilho profissional.",
    items: ["Verniz Gel", "Unhas de Gel", "Acrílico"],
    image: IMAGES.manicureLamps,
  },
  {
    id: "pedicure",
    num: "02",
    title: "Pedicure Spa dos Pés",
    desc: "Relaxamento, esfoliação e cuidado completo para pés bonitos e saudáveis.",
    items: ["Spa dos Pés", "Esfoliação", "Hidratação Profunda"],
    image: IMAGES.manicureDesk,
  },
  {
    id: "sobrancelhas",
    num: "03",
    title: "Design de Sobrancelhas",
    desc: "Harmonização do olhar com design personalizado ao formato do seu rosto.",
    items: ["Design Personalizado", "Harmonização do Olhar"],
    image: IMAGES.vanity,
  },
  {
    id: "depilacao",
    num: "04",
    title: "Depilação",
    desc: "Pele suave e cuidada com técnicas seguras, confortáveis e higienizadas.",
    items: ["Depilação a Cera", "Depilação Laser"],
    image: IMAGES.treatmentRoom,
  },
];

export const TESTIMONIALS = [
  {
    name: "Mariana Costa",
    service: "Verniz Gel",
    text: "O melhor espaço de unhas onde já estive. Ambiente impecável, super acolhedor e o verniz gel durou semanas perfeitas. Atendimento VIP de verdade!",
  },
  {
    name: "Sofia Almeida",
    service: "Pedicure Spa",
    text: "O spa dos pés é uma experiência maravilhosa. Saí de lá renovada. Nota-se o cuidado com a higiene em cada detalhe. Recomendo de olhos fechados.",
  },
  {
    name: "Inês Ferreira",
    service: "Design de Sobrancelhas",
    text: "A harmonização do olhar transformou o meu rosto. Profissionais super qualificadas e um espaço lindo, todo decorado em tons de rosa. Adorei!",
  },
  {
    name: "Carla Rodrigues",
    service: "Unhas de Gel",
    text: "Materiais esterilizados, atendimento atencioso e um resultado perfeito. Virou o meu salão de confiança. Vale cada minuto!",
  },
];
